<form
    [ngClass]="isOrderSummaryAddress ? 'order-summary-address' : 'address'"
    name="address-form"
    [formGroup]="formGroup"
>
    <h5>{{heading}}</h5>
    <br *ngIf="isOrderSummaryAddress" />
    <div class="form-group sub-heading">
        <div style="margin-bottom: 20px;"><span class="required fa fa-asterisk"></span> Indicates required fields.</div>
    </div>
    <div class="form-container compact">
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label>Full Name <span class="required fa fa-asterisk"></span></label>
                    <input
                        type="text"
                        class="form-control"
                        formControlName="fullName"
                        name="fullName"
                        [ngClass]="{ 'is-invalid': submitted && f.fullName.errors }"
                        placeholder="Full Name"
                    />
                    <small
                        class="error"
                        *ngIf="submitted && f.fullName.errors"
                    >Please enter a full name.</small>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label>Address/Street/PO Box <span class="required fa fa-asterisk"></span></label>
                    <input
                        type="text"
                        class="form-control"
                        name="addressLine1"
                        formControlName="addressLine1"
                        maxlength="60"
                        [ngClass]="{ 'is-invalid': submitted && f.addressLine1.errors }"
                        data-qa="checkout-address-streetText"
                        placeholder="Address/Street/PO Box"
                    />
                    <small
                        class="error"
                        *ngIf="submitted && f.addressLine1.errors"
                    >Please enter an address.</small>
                    <br />
                    <input
                        type="text"
                        class="form-control"
                        name="addressLine2"
                        formControlName="addressLine2"
                        maxlength="60"
                        placeholder="Address Line 2"
                    />
                </div>
            </div>
        </div>

        <!-- Removed row and col from suit and buzzer number to fix styles on checkout/address design -->
        <div class="suit form-group">
            <label>Apartment/Suite</label>
            <input
                type="text"
                maxlength="50"
                class="form-control"
                name="suite"
                formControlName="suite"
                placeholder="Apartment, Suite, or Building (optional)"
            />
        </div>

        <div class="buzzer form-group">
            <label>Buzzer Number</label>
            <input
                type="text"
                class="form-control"
                name="buzzerNumber"
                placeholder="Optional"
                maxlength="12"
                formControlName="buzzerNumber"
            />
        </div>

        <div class="row">
            <div
                [ngClass]="{'col-sm-6':isOrderSummaryAddress}"
                class="col-12"
            >
                <div class="form-group">
                    <label>City <span class="required fa fa-asterisk"></span></label>
                    <input
                        type="text"
                        class="form-control"
                        name="city"
                        formControlName="city"
                        maxlength="50"
                        [ngClass]="{ 'is-invalid': submitted && f.city.errors }"
                        data-qa="checkout-address-cityText"
                        placeholder="City"
                    />
                    <small
                        class="error"
                        *ngIf="submitted && f.city.errors"
                    >Please enter a city.</small>
                </div>
            </div>
            <div
                [ngClass]="{'col-sm-6':isOrderSummaryAddress}"
                class="col-12"
            >
                <div
                    class="form-group"
                    *ngIf="regions?.length > 0; else useRegionAbbrOrName"
                >
                    <label>Province/State <span class="required fa fa-asterisk"></span></label>
                    <select
                        class="form-control"
                        formControlName="regionAbbrOrName"
                        name="region"
                        [ngClass]="{ 'is-invalid': submitted && f.regionAbbrOrName.errors }"
                        data-qa="checkout-address-selectProvince"
                        placeholder="Province/State"
                    >
                        <option [ngValue]="null">Select a region</option>
                        <option
                            *ngFor="let region of regions"
                            [value]="region.abbreviation"
                        >
                            {{region.name}}
                        </option>
                    </select>
                    <small
                        class="error"
                        *ngIf="submitted && f.regionAbbrOrName.errors"
                    >Please enter a province/state.</small>
                </div>
            </div>
        </div>

        <ng-template #useRegionAbbrOrName>
            <div class="form-group">
                <label>Province/State <span class="required fa fa-asterisk"></span></label>
                <input
                    type="text"
                    class="form-control"
                    formControlName="regionAbbrOrName"
                    name="region"
                    maxlength="20"
                    [ngClass]="{ 'is-invalid': submitted && f.regionAbbrOrName.errors }"
                    data-qa="checkout-address-selectProvince"
                    placeholder="Region"
                />
                <small
                    class="error"
                    *ngIf="submitted && f.regionAbbrOrName.errors"
                >Please enter a region.</small>
            </div>
        </ng-template>

        <div class="row">
            <div
                [ngClass]="{'col-sm-6':isOrderSummaryAddress}"
                class="col-12"
            >
                <div class="form-group">
                    <label>Postal/Zip Code <span class="required fa fa-asterisk"></span></label>
                    <input
                        type="text"
                        class="form-control"
                        formControlName="postalCode"
                        name="postalCode"
                        maxlength="20"
                        [ngClass]="{ 'is-invalid': submitted && f.postalCode.errors }"
                        data-qa="checkout-address-postalCodeText"
                        placeholder="Postal/Zip Code"
                    />
                    <small
                        class="error"
                        *ngIf="submitted && f.postalCode.errors?.required"
                    >Please enter a postal/zip code.</small>
                </div>
            </div>
            <div
                [ngClass]="{'col-sm-6':isOrderSummaryAddress}"
                class="col-12"
            >
                <div class="form-group">
                    <label>Country <span class="required fa fa-asterisk"></span></label>
                    <select
                        type="text"
                        class="form-control"
                        name="countryId"
                        formControlName="countryId"
                        [ngClass]="{ 'is-invalid': submitted && f.countryId.errors }"
                    >
                        <option
                            *ngFor="let country of countries"
                            [value]="country.id"
                        >
                            {{country.name}}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <div class="row">
            <div
                [ngClass]="{'col-sm-6':isOrderSummaryAddress}"
                class="col-12"
            >
                <div class="form-group">
                    <label>Phone Number <span class="required fa fa-asterisk"></span></label>
                    <input
                        type="text"
                        class="form-control"
                        formControlName="phoneNumber"
                        name="phoneNumber"
                        [ngClass]="{ 'is-invalid': submitted && f.phoneNumber.errors }"
                        data-qa="checkout-address-phoneNumberText"
                        placeholder="Phone Number"
                    />
                    <small
                        class="error"
                        *ngIf="f.phoneNumber.errors?.pattern"
                    >
                        Please enter a phone number that contains only numbers and no spaces, dashes or brackets</small>
                    <small
                        class="error"
                        *ngIf="f.phoneNumber.dirty && f.phoneNumber.errors?.minlength || submitted && f.phoneNumber.errors?.minlength"
                    >Please enter a phone number with minimum length of 5.</small>
                    <small
                        class="error"
                        *ngIf="submitted && f.phoneNumber.errors?.required"
                    >Please enter a phone number.</small>
                </div>
            </div>
        </div>
    </div>
</form>
